import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {SurveyService} from './../../surveys.service';
import {SurveyCreatePDModel, SurveyLanguageModel} from './../../../../models/survey/survey.model';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';

@Component({
  selector: 'app-define-tab',
  templateUrl: './define-tab.component.html',
  styleUrls: ['./define-tab.component.less']
})
export class DefineTabComponent implements OnInit {

  info: boolean;
  infoText1: string;
  infoText2 = 'People Data Enrichment Survey... People Data Enrichment Survey... People Data Enrichment Survey...';
  addLang: boolean;
  dropdownLabelLanguage: string;
  selectedLanguage: SurveyLanguageModel;
  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();
  isAdmin = AuthTokenService.isAdmin();

  constructor(public surveyService: SurveyService) {
  }

  ngOnInit() {
    this.info = false;
    this.addLang = false;
    this.dropdownLabelLanguage = 'Select';
    this.selectedLanguage = new SurveyLanguageModel();
  }

  save() {
    this.surveyCreatePDModelChange.emit(this.surveyService.surveyCreatePDModel);
  }


  showInfoWhatToLearn() {
    this.info = true;
    this.surveyService.surveyCreatePDModel.whatToLearnPop = true;
    this.surveyService.surveyCreatePDModel.appropriateFormatPop = false;
    this.surveyService.surveyCreatePDModel.whoToTalkPop = false;
  }

  showInfoWhoToTalk() {
    this.info = true;
    this.surveyService.surveyCreatePDModel.whatToLearnPop = false;
    this.surveyService.surveyCreatePDModel.appropriateFormatPop = false;
    this.surveyService.surveyCreatePDModel.whoToTalkPop = true;

  }

  showInfoFormat() {
    this.info = true;
    this.surveyService.surveyCreatePDModel.whatToLearnPop = false;
    this.surveyService.surveyCreatePDModel.appropriateFormatPop = true;
    this.surveyService.surveyCreatePDModel.whoToTalkPop = false;

  }

  addLanguage() {
    if (this.selectedLanguage.languageId == undefined)
      return false;
    else {
      this.addLang = true;
    }
  }

  removeLanguage(id) {
    let item = this.surveyService.surveyCreatePDModel.listSelectedSurveyLanguageModel.find(a => a.languageId == id);
    let index: number = this.surveyService.surveyCreatePDModel.listSelectedSurveyLanguageModel.indexOf(item);
    this.surveyService.surveyCreatePDModel.listSelectedSurveyLanguageModel.splice(index, 1);
  }

  editLanguage(id) {
  }


  changeLanguage(e) {
    if (e == 'Any') {
      this.selectedLanguage = null;
    } else {
      this.selectedLanguage.languageId = e.id;
      this.selectedLanguage.languageName = e.name;
      this.selectedLanguage.surveyId = this.surveyService.surveyCreatePDModel.id;
    }
  }

  assignTranslator(id) {
    if (id != undefined) {
      this.selectedLanguage.translatorId = id;

      this.surveyService.surveyCreatePDModel.listSelectedSurveyLanguageModel.push(this.selectedLanguage);
      this.selectedLanguage = new SurveyLanguageModel();
    }
  }

  changeText(e) {
    if (this.surveyService.surveyCreatePDModel.whatToLearnPop) {
      this.surveyService.surveyCreatePDModel.whatToLearn = this.infoText2;
    } else if (this.surveyService.surveyCreatePDModel.whoToTalkPop) {
      this.surveyService.surveyCreatePDModel.whoToTalk = this.infoText2;
    } else if (this.surveyService.surveyCreatePDModel.appropriateFormatPop) {
      this.surveyService.surveyCreatePDModel.appropriateFormat = this.infoText2;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/define-tab/define-tab.component.ts